import { render, staticRenderFns } from "./PurchaseChangeData.vue?vue&type=template&id=118edb12&scoped=true"
import script from "./PurchaseChangeData.vue?vue&type=script&lang=js"
export * from "./PurchaseChangeData.vue?vue&type=script&lang=js"
import style0 from "./PurchaseChangeData.vue?vue&type=style&index=0&id=118edb12&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118edb12",
  null
  
)

export default component.exports